import { render, staticRenderFns } from "./cateNextLvFooter.vue?vue&type=template&id=54536326&scoped=true"
import script from "./cateNextLvFooter.vue?vue&type=script&lang=js"
export * from "./cateNextLvFooter.vue?vue&type=script&lang=js"
import style0 from "./cateNextLvFooter.vue?vue&type=style&index=0&id=54536326&prod&lang=scss"
import style1 from "./cateNextLvFooter.vue?vue&type=style&index=1&id=54536326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54536326",
  null
  
)

export default component.exports